import { render, staticRenderFns } from "./ActionsCell.vue?vue&type=template&id=15723cbc&scoped=true&"
import script from "./ActionsCell.vue?vue&type=script&lang=js&"
export * from "./ActionsCell.vue?vue&type=script&lang=js&"
import style0 from "./ActionsCell.vue?vue&type=style&index=0&id=15723cbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15723cbc",
  null
  
)

export default component.exports